export default {
    vmLogUpdated: 'VM Log aktualisiert',
    Errored: 'Fehlgeschlagen',
    Finished: 'Beendet',
    Waiting: 'Wartend',
    Running: 'Läuft',
    'Cleanup after abort': 'Abgebrochen',
    Aborting: 'Wird abgebrochen',
    STARTED: 'GESTARTET',
    DATA_ARRIVED_ON_VM: 'DATEN AUF VM ANGEKOMMEN',
    CAD_IMPORT: 'CAD IMPORT',
    SINGLE_EXTRACT: 'EINZELTEILE EXTRAKT',
    GROUP_EXTRACT: 'GRUPPEN EXTRAKT',
    TRANSFER_DATA_TO_VHUB: 'DATEN AN VHUB ÜBERTRAGEN',
    CREATING_ASSETS: 'ERSTELLEN VON ASSETS',
    CREATING_INSTANCES: 'ERSTELLEN VON INSTANZEN',
    ATTACHING_METADATA: 'METADATEN ANHÄNGEN',
    SETTING_METAVALUES: 'METAWERTE SETZEN',
    SETTING_CUSTOM_META_VALUES: 'EIGENE METAWERTE SETZEN',
    FINISHED: 'ABGESCHLOSSEN',
    PROCESSED: 'VERARBEITET',
    PROCESSING_INSTANCES: 'INSTANZ VERARBEITUNG',
    PROCESSING_MATERIALS: 'MATERIALEN APPLIZIEREN',
    timePrediction: 'Zeit-Vorhersage',
    geometries: 'parts',
    vertices: 'vertices',
    groups: 'groups',
    createdby: 'Erstellt',
    updatedby: 'Aktualisiert',
    totaltime: 'Gesamtzeit',
    vmtime: 'VM ZEIT',
    instanceUpdating: 'Instanzen-Aktualisierung',
    dataprocessing: 'Meta-Daten-Update',
    createVersion: 'Version erstellen',
    restoreVersion: 'Version wiederherstellen',
    deleteVersion: 'Version löschen',
    extract: 'Import',
    update: 'Update',
    convertAssembly: 'Konvertierung Baugruppe',
    dataprocessingAbortMessage: 'Wollen Sie die Meta-Daten-Aktualisierung wirklich abbrechen?',
    dataprocessingAbortedMessage: 'Die Meta-Daten-Aktualisierung wurde abgebrochen.',
    applyMaterialAbortMessage: 'Wollen Sie die Material-Applizierung wirklich abbrechen?',
    applyMaterialAbortedMessage: 'Die Material-Applizierung wurde abgebrochen.',
    convertHelperAbortMessage: 'Wollen Sie die Konvertierung wirklich abbrechen?',
    convertHelperAbortedMessage: 'Die Konvertierung wurde abgebrochen.',
    convertAssemblyAbortMessage: 'Wollen Sie die Baugruppen-Konvertierung wirklich abbrechen?',
    convertAssemblyAbortedMessage: 'Die Baugruppen-Konvertierung wurde abgebrochen.',
    instanceUpdatingAbortMessage: 'Wollen Sie die Instanz-Aktualisierung wirklich abbrechen?',
    instanceUpdatingAbortedMessage: 'Die Instanz-Aktualisierung wurde abgebrochen.',
    filterAbortMessage: 'Wollen Sie die Filterung wirklich abbrechen?',
    filterAbortedMessage: 'Die Filterung wurde abgebrochen.',
    extractAbortMessage: 'Wollen Sie den Import wirklich abbrechen? Der Prozess wird gestoppt und Ihre CAD-Dateien werden von unseren Systemen entfernt.',
    extractAbortedMessage: 'Der Import wurde abgebrochen. Ihre CAD-Dateien wurden von unseren Systemen entfernt. Wenn der letzte Status einer der folgenden Schritte ist, brauchen Sie nichts weiter zu unternehmen. Ist er dagegen danach, dann müssen Sie aller Wahrscheinlichkeit nach ihre Baugruppe auf eine vorherige Version zurücksetzen: {steps}',
    updateAbortMessage: 'Wollen Sie das Update wirklich abbrechen? Der Prozess wird gestoppt und Ihre CAD-Dateien werden von unseren Systemen entfernt.',
    updateAbortedMessage: 'Das Update wurde abgebrochen. Ihre CAD-Dateien wurden von unseren Systemen entfernt. Wenn der letzte Status einer der folgenden Schritte ist, brauchen Sie nichts weiter zu unternehmen. Ist er dagegen danach, dann müssen Sie aller Wahrscheinlichkeit nach ihre Baugruppe auf eine vorherige Version zurücksetzen: {steps}',
    SuccessfullyInmported: 'Erfolgreich importiert',
    ErroredImporting: 'Fehler beim Importieren',
    deleteTaskAndCADFiles: 'Prozess und hochgeladene Dateien löschen',
    cleanup: 'Abbruch Cleanup',
    cannotStartProcessIsRunning: 'Starten nicht möglich, Prozess im Gange',
    importAbort: 'Abbrechen',
    importStart: 'Import starten',
    exportGroups: 'Gruppen exportieren',
    exportParts: 'Einzelteile exportieren',
    exportPreviews: 'Bilder exportieren',
}